import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    BooleTypes,
    ExhibitTypes,
    FurnitureTypes,
    LightsTypes,
    PartitionTypes,
    ReceptionTypes,
    TVTypes,
} from './current-model-state';

export type ModelState = {
    color: string;
    reception: ReceptionTypes;
    tvFirst?: TVTypes;
    tvSecond?: TVTypes;
    exhibit?: ExhibitTypes;
    exhibitSecond?: ExhibitTypes;
    lightsFirst?: LightsTypes;
    lightsSecond?: LightsTypes;
    furnitureFirst?: FurnitureTypes;
    furnitureSecond?: FurnitureTypes;
    boole?: BooleTypes;
};

const currentPickerState = atom<{
    title: string;
    slug:
        | 'reception'
        | 'tvFirst'
        | 'tvSecond'
        | 'exhibit'
        | 'exhibitSecond'
        | 'lightsFirst'
        | 'lightsSecond'
        | 'furnitureFirst'
        | 'furnitureSecond'
        | 'boole'
        | 'partition';
    property: {
        label: string;
        slug: ReceptionTypes | LightsTypes | TVTypes | FurnitureTypes | ExhibitTypes | BooleTypes | PartitionTypes;
        hint: string;
    }[];
}>({
    key: 'currentPickerState',
    default: {
        title: 'Стойка ресепшн',
        slug: 'reception',
        property: [
            { label: 'Большая стойка с нишей', slug: 'type-1-big', hint: 'описание' },
            { label: 'Большая стойка с нишей', slug: 'type-1-big', hint: 'описание' },
        ],
    },
});

export const useCurrentPickerStateValue = () => useRecoilValue(currentPickerState);

export const useSetCurrentPickerState = () => useSetRecoilState(currentPickerState);
